import { useFormikContext } from 'formik';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { Stack, Typography } from '@mui/material';

import { CheckboxUI } from '../Interface';

const ItemCategoryItemLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateItemCategoryItemLink = (nodes, itemCategoryId, isChecked) =>
    nodes.map((node) => ({
      ...node,
      checked: node.id === itemCategoryId ? isChecked : node.checked,
      children: updateItemCategoryItemLink(node.children || [], itemCategoryId, isChecked),
    }));

  const handleCheckChange = (itemCategoryId, isChecked) => {
    const updatedLinks = updateItemCategoryItemLink(values.itemCategoryItemLink || [], itemCategoryId, isChecked);

    setFieldValue('itemCategoryItemLink', updatedLinks);
  };

  const renderTree = (node) => (
    <TreeItem
      key={node.id}
      itemId={String(node.id)}
      label={
        <Stack direction="row" spacing={1}>
          <CheckboxUI
            sx={{ m: 0, p: 0 }}
            disabled={disabled}
            onChange={(e) => handleCheckChange(node.id, e.target.checked)}
            onClick={(e) => e.stopPropagation()}
            checked={node.checked || false}
          />
          <Typography>{node.name}</Typography>
        </Stack>
      }
    >
      {node.children?.map((child) => renderTree(child))}
    </TreeItem>
  );

  return <SimpleTreeView>{values?.itemCategoryItemLink?.map((node) => renderTree(node))}</SimpleTreeView>;
};

export default ItemCategoryItemLinks;
